import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';
import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import { ViewProps } from './rive.constants';
import { ImageViewWrapper } from '../image/image.style';
import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import { ActivityBuilderPrintStaticImage } from 'approot/activity-builder/print/activity-builder-print-image';
import { getPrintImage } from '../shared/logic/get-print-image';

const RivePrint = ({ properties }: ViewProps) => {
  const imageUrl = getPrintImage(properties.imageUrls);

  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl,
  });
  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(properties.dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper>
        <ImageViewWrapper ref={setContainerElement}>
          <ActivityBuilderPrintStaticImage
            imageUrl={imageUrl}
            imageDimensions={imageDimensions}
            altText={properties.image?.alt || ''}
          />
        </ImageViewWrapper>
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};

export default RivePrint;
